import { createRouter, createWebHistory } from 'vue-router'
// 登录界面
import Login from '../views/login/UserLogin.vue'
//主页
import Home from '../views/home/HomeViews.vue'
//更新日志
import UpdateLog from '../views/updateLog/UpdateLog.vue'
//图库
import PhotoLibrary from '../views/photoLibrary/photoLibrary.vue'
//博客详情
import BlogInfo from '../views/blogInfo/blogInfo.vue'
import BlogInfoWrite from '../views/blogInfo/blogInfoWrite.vue'


//示例
import exampleView from '../views/example/exampleView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/UpdateLog',
    name: 'UpdateLog',
    component: UpdateLog
  },
  {
    path: '/PhotoLibrary',
    name: 'PhotoLibrary',
    component: PhotoLibrary
  },
  {
    path: '/BlogInfo/:id',
    name: 'BlogInfo',
    component: BlogInfo
  },
  {
    path: '/BlogInfoWrite',
    name: 'BlogInfoWrite',
    component: BlogInfoWrite
  },


  {
    path: '/exampleView',
    name: 'exampleView',
    component: exampleView
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../components/sakura/sakura.vue')
  // }

  {
    path: '/TerminalError',
    name: 'TerminalError',
    component: () => import('../views/404/TerminalError.vue'),
  },
  {
    path: '/404',
    name: '404page',
    component: () => import('../views/404/PageNotFound.vue'),
  },

  // 使用 * 作为通配符来匹配所有未定义的路由  
  {
    path: '/:pathMatch(.*)',
    redirect: '/404',
    hidden: true
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.afterEach(() => {  
  // 跳转到新页面后滚动到顶部  
  window.scrollTo(0, 0);  
});
export default router
